import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileboxOperationEnum } from '../enums/filebox-operation.enum';
import { FileboxStatusEnum } from '../enums/filebox-status.enum';

/**
 * Filebox DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.FILEBOX)
export class FileboxSearchDto extends BaseSearchDto {
	tenantId!: number;
	userId!: number;
	status!: FileboxStatusEnum;
	operation!: FileboxOperationEnum;
	key!: string;
	fileUuid!: string;
	synchronizationToken!: string;
	retryCount!: number;
	nextRetryAt?: Date;
	leasedBy?: string;
	leasedUntil?: Date;
	synchronizedAt?: Date;
	synchronizationError?: string;

	displayValue(): string | null {
		return null;
	}

	shortDisplayValue(): string | null {
		return null;
	}

	periodDisplayValue(): string | null {
		return null;
	}

	extraDisplayValue(): string | null {
		return null;
	}

	pillDisplayValue(): string {
		return `${this.status}`;
	}
}
